export enum RoutesEnum {
  OVERVIEW = '/dashboard',
  SALES_PROFIT = '/sales-profit',
  PROFIT_LOSS = '/profit-loss',
  VAT_SETTINGS = '/vat-settings',
  INVENTORY = '/inventory',
  WAREHOUSE = '/warehouse',
  SETTINGS = '/settings',
  MANUAL_ADJUSTMENTS = '/manual-adjustments',
  CUSTOMERS = '/customers',
  ORDERS = '/orders',
  MARKETING = '/marketing',
  PARTNER = '/partner'
}
